import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useBizCategory = (param: BizCategoryListReqDto) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [bizCateList, setBizCateList] = useState<BizCategoryListDto[] | any[]>();
  const [bizCateSubList, setBizCateSubList] = useState<BizCategoryListDto[] | any[]>();
    
  /* ======================================================
   * hooks
   * ====================================================== */
  const { isLoading, refetch } = useQuery(
    [endpoints.refcode.bizlist],
    () =>
      fetcher.refcode.getBizCategoryList(param),
    {
      onSuccess: (res: RefCodeListResDto) => {
        switch (res.code) {
          case 200:
            setBizCateList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  ); 

  const { mutate: bizCategorySubList } = useMutation(
    [endpoints.refcode.bizlist],
    fetcher.refcode.getBizCategoryList,
    {
      onSuccess: (res, param) => {
        switch (res.code) {
          case 200:
            setBizCateSubList(res.result?.list);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: bizCategoryInsert } = useMutation(
    [endpoints.refcode.bizadd],
    fetcher.refcode.postBizCategoryInsert,
    {
      onSuccess: (res, param) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            if (param.main_biz_category_srl != 0) {
              bizCategorySubList({main_biz_category_srl: param.main_biz_category_srl});
            } else refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: bizCategoryUpdate } = useMutation(
    [endpoints.refcode.bizupdate],
    fetcher.refcode.postBizCategoryUpdate,
    {
      onSuccess: (res, param) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            if (param.main_biz_category_srl != 0) {
              bizCategorySubList({main_biz_category_srl: param.main_biz_category_srl});
            } else refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: bizCategorySort } = useMutation(
    [endpoints.refcode.bizsort],
    fetcher.refcode.postBizCategorySort,
    {
      onSuccess: (res, param) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            if (param.main_biz_category_srl != 0) {
              bizCategorySubList({main_biz_category_srl: param.main_biz_category_srl});
            } else refetch();            
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )    

  return { isLoading, bizCateList, bizCateSubList, bizCategorySubList, refetch, bizCategoryInsert, bizCategoryUpdate, bizCategorySort };
};

export default useBizCategory;
